<template>
    <div class="modal_wrapper image">
        <i @click="cancel" class="el-icon-close"></i>
        <div class="modal image-view">
            <img :src="url" alt="">
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      url: {type: String, default: ''}
    },
    methods: {
      cancel () {
        this.$emit('cancel')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal-image.vue